import React from 'react';
import Input from '../input';
import "./index.css";
import Button from '../button';

const Avatar = (props) => {

    const {className, size, src, draggable, editableAvatar, browseHandler, clickHandler, ...other} = props;

    return (
        <div
            className={`avatar${className ? ' ' + className : ''}`}
            style={{
                minWidth: size,
                maxWidth: size,
                maxHeight: size,
                width: size,
                height: size
            }} {...other}
        >
            {
                editableAvatar
                ?
                    <>
                        <Input type="file" onChange={browseHandler} />
                        <Button className="edit" onClick={clickHandler}>
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path
                                    d="M20 10h-2V7h-3V5h3V2h2v3h3v2h-3v3zm-4 3c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4zm4-1v7H4V7h9V3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-7h-2z"/>
                            </svg>
                        </Button>
                    </>
                :
                    null
            }
            <img draggable={draggable} style={{width: size, height: size}} src={src} alt=""/>
        </div>
    );
};

export default Avatar;